import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgUserIconSecondary(props) {
  return jsx("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M15.25 16c-.41 0-.75-.34-.75-.75v-1.39c0-1.48-.65-2.23-1.92-2.23h-1.13c-1.47 0-2.49-.86-2.49-2.08 0-.81.44-1.3.8-1.69.41-.45.76-.84.76-1.87V4.06c0-1.77-1.27-2.56-2.54-2.56-1.01 0-2.5.7-2.5 2.63v1.68c0 1.14.35 1.53.76 1.98.36.39.8.89.8 1.75 0 1.02-.93 2.08-2.49 2.08H3.42c-1.28 0-1.92.75-1.92 2.23v1.39a.751.751 0 1 1-1.5.01v-1.39c0-2.3 1.31-3.73 3.42-3.73h1.13c.64 0 .99-.34.99-.58 0-.28-.11-.41-.41-.75-.48-.54-1.15-1.27-1.15-2.98V4.13c0-2.68 2.06-4.13 4-4.13 2.34 0 4.04 1.71 4.04 4.06v1.93c0 1.6-.67 2.34-1.15 2.88-.31.34-.41.47-.41.68 0 .43.53.58.99.58h1.13c2.11 0 3.42 1.43 3.42 3.73v1.39c0 .41-.34.75-.75.75Z",
    fill: "currentColor"
  }));
}

export { SvgUserIconSecondary as default };
